import { useCallback } from "react";

import * as Events from "@app/analytics/MeetingReport/tracking/events";
import * as ShareUtils from "@app/common/access/ShareReport/utils";
import { LinkIcon } from "@app/common/assets/icons";
import { toast } from "@app/common/hooks/useToasts";

import CopyButton from "@rui/CopyButton";
import MenuItem from "@rui/MenuItem";

const CopyLinkMenuItem = ({ sessionId }: { sessionId: string }) => {
  const handleClickCopy = useCallback(() => {
    Events.copyReportUrl();
    toast.success("Copied link to clipboard!");
  }, []);

  return (
    <CopyButton
      onClick={handleClickCopy}
      copyValue={ShareUtils.getReportShareLink(sessionId, "nav")}
      renderButton={(props) => (
        <MenuItem icon={<LinkIcon />} {...props}>
          Copy link
        </MenuItem>
      )}
    />
  );
};

export default CopyLinkMenuItem;
